// Custom debug logging function
function debugLog(...args) {
    const custom = document.getElementById("gift-script");
    if (custom?.hasAttribute("debug_gift")) {
      console.log(...args);
    }
}
debugLog("✅ Gift with Purchase Script Loaded");

// Global gift tracker
    var gift = {
    freeItemAdded: false,
    cartUpdated: function () {
        debugLog("🛒 Item added to cart");
    },
};

document.addEventListener("DOMContentLoaded", function () {
    // CONFIGURATION
    const giftRuleConfig = window.theme?.settings?.giftRuleConfig || {}; // Default to an empty object if undefined
    // Use safe access for each property in giftRuleConfig
    const FREE_GIFT_ID = giftRuleConfig.free_gift_variant_id || null; // Set default to null if undefined
    const FREE_GIFT_THRESHOLD = giftRuleConfig.spend_threshold || 0; // Default to 0 if undefined
    const ELIGIBLE_COUNTRIES = giftRuleConfig.eligible_countries || []; // Default to empty array if undefined
    const ELIGIBLE_CUSTOMER_TAGS = giftRuleConfig.eligible_customer_tags || []; // Default to empty array if undefined
    const ELIGIBLE_COLLECTION_HANDLES = giftRuleConfig.eligible_collection_handles || []; // Default to empty array if undefined
    const START_DATE = giftRuleConfig.start_date ? new Date(giftRuleConfig.start_date) : null; // Default to null if undefined
    const END_DATE = giftRuleConfig.end_date ? new Date(giftRuleConfig.end_date) : null; // Default to null if undefined

    // Log the configuration to help with debugging

    // Check if the free gift variant ID is missing
    if (!FREE_GIFT_ID) {
        console.error("Gift rule configuration is missing the free gift variant ID.");
        return; // Exit early if the free gift variant ID is not provided
    }

    let isProcessing = false;

    // Fetch the current cart
    function fetchCart() {
        return fetch("/cart.js")
        .then((res) => res.json())
        .catch((err) => console.error("Error fetching cart:", err));
    }

    // Add the free gift to cart
    function addFreeGift() {
        gift.freeItemAdded = true;
        isProcessing = true;
        return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: FREE_GIFT_ID, quantity: 1 }),
        })
        .then(() => fetchCart()) // <-- wrap in function
        .then((cart) => {
            updateCartUI(cart);
            isProcessing = false;
        })
        .catch((err) => {
            console.error("Error adding gift:", err);
            isProcessing = false;
        });
    }

    // Remove the free gift from cart
    function removeFreeGift(lineItemKey) {
        isProcessing = true;
        return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
        })
        .then(() => fetchCart()) // <-- wrap in function
        .then((cart) => {
            updateCartUI(cart);
            isProcessing = false;
        })
        .catch((err) => {
            console.error("Error removing gift:", err);
            isProcessing = false;
        });
    }

    // Update cart count UI if present
    function updateCartUI(cart) {
        const cartCountElement = document.querySelector(".cart-count");
        if (cartCountElement) {
            cartCountElement.textContent = cart.item_count;
        }
        if (window.saveCart?.refresh) {
            saveCart.refresh();
        } 
        if (window.saveCartDrawer?.refresh) {
            saveCartDrawer.refresh();
        }

        // Known refresh handlers
        if (window.CartDrawer?.refresh) {
            window.CartDrawer.refresh();
            return;
        }

        if (window.theme?.cart?.refresh) {
            window.theme.cart.refresh();
            return;
        }

        if (window.Shopify?.cart?.update) {
            window.Shopify.cart.update(cart);
            return;
        }

        // Dispatch custom events for any event listeners
        const cartDrawer = document.querySelector("cart-drawer, .cart-drawer, .mini-cart");
        if (cartDrawer && typeof cartDrawer.dispatchEvent === "function") {
        cartDrawer.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        }

        // Fire a global update event
        const globalEvent = new CustomEvent("cart:updated", { detail: cart });
        document.dispatchEvent(globalEvent);
    }

    // Fetch collection data for a list of product GIDs

    async function fetchEligibleCollections(productGIDs) {
        try {
            if (!Array.isArray(productGIDs) || productGIDs.length === 0) {
                debugLog("⚠️ No product GIDs provided for collection check.");
                return [];
            }
    
            const queryParam = productGIDs.map(encodeURIComponent).join(",");
            const res = await fetch(`/apps/discounts/collection-check?product_ids=${queryParam}`);
            // If the response is not ok (e.g., status code is not 2xx), throw an error
            if (!res.ok) {
                throw new Error(`Failed to fetch, status: ${res.status}`);
            }
            const { data } = await res.json();
            return data;
        } catch (err) {
            console.error("❌ Error fetching collection data:", err);
            return [];
        }
    }

    // Main function to check eligibility and apply/remove the gift
    async function checkAndApplyGift() {
        if (isProcessing) {
            return;
        }

        const cart = await fetchCart();
        if (!cart || !Array.isArray(cart.items)) {
            console.error("⚠️ Cart data is missing or invalid:", cart);
            return;
        }
        const now = new Date();
        const timeEligible = now >= START_DATE && now <= END_DATE;

        const customerCountry = window.theme?.settings?.customer_country_code || "";
        const customerTags = window.theme?.settings?.customer_tags || [];
        const countryEligible = ELIGIBLE_COUNTRIES.length === 0 || ELIGIBLE_COUNTRIES.includes(customerCountry);
        const tagEligible = ELIGIBLE_CUSTOMER_TAGS.length === 0 ||
        customerTags.some((tag) =>
            ELIGIBLE_CUSTOMER_TAGS.includes(tag)
        );


        const freeGiftItem = cart.items.find((item) => item.variant_id === FREE_GIFT_ID);
        const freeGiftExists = !!freeGiftItem;
        
        if (!timeEligible) {
            if (freeGiftExists) {
                removeFreeGift(freeGiftItem.key);
            }
            return;
        }
        // Get all cart product GIDs excluding the free gift
        const cartProductGIDs = cart.items
        .filter((item) => item.variant_id !== FREE_GIFT_ID && item.product_id)
        .map((item) => `gid://shopify/Product/${item.product_id}`);

        const collectionData = await fetchEligibleCollections(cartProductGIDs);
        // Map product ID to whether it belongs to an eligible collection
        const eligibleProductIds = Array.isArray(collectionData)
        ? collectionData
            .filter((product) =>
                Array.isArray(product?.collections) &&
                product.collections.some((collection) =>
                    ELIGIBLE_COLLECTION_HANDLES.includes(collection?.handle)
                )
            )
            .map((product) => {
                const id = product?.id?.split("/").pop();
                return parseInt(id, 10);
            })
            .filter((id) => !isNaN(id)) //This filters out those bad results: [123456, NaN, 7890].filter((id) => !isNaN(id)) // → [123456, 7890]

        : [];

        // Calculate total only for eligible collection products
        const eligibleCollectionTotal = cart.items
        .filter(
            (item) =>
            item.variant_id !== FREE_GIFT_ID &&
            eligibleProductIds.includes(item.product_id)
        )
        .reduce((sum, item) => sum + (item.line_price || 0), 0) / 100;

        const isEligible =
            timeEligible &&
            countryEligible &&
            tagEligible &&
            eligibleCollectionTotal >= FREE_GIFT_THRESHOLD;
        if (isEligible && !freeGiftExists) {
            addFreeGift();
        } else if (!isEligible && freeGiftExists) {
            removeFreeGift(freeGiftItem.key);
        } else {
            debugLog("✅ Gift state is correct. No action needed.");
        }
    }

    // Patch fetch to hook into AJAX updates (cart/add, cart/change)
    (function () {
        const originalFetch = window.fetch;
        window.fetch = async function (resource, config) {
        const response = await originalFetch(resource, config);
        if (typeof resource === "string" && resource.includes("/cart")) {
            try {
                response.clone().json().then(() => {
                    if (
                        response.url.includes("cart/add") ||
                        response.url.includes("cart/change")
                    ) {
                        checkAndApplyGift();
                    }
                });
            } catch (err) {
                console.warn("⚠️ Fetch patch error:", err);
            }
        }
            return response;
        };
    })();

    // Initial eligibility check on page load
    checkAndApplyGift();
});